/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KursInfoVO } from './kursInfoVO';


export interface KursanmeldungVO { 
    id: number;
    zertifizierungstyp: KursanmeldungVO.ZertifizierungstypEnum;
    bezahlt: boolean;
    storniert: boolean;
    teilgenommen: boolean;
    kurs: KursInfoVO;
    zahlungStorniert?: boolean;
    widerrufStatus?: KursanmeldungVO.WiderrufStatusEnum;
    zertifikatVorhanden?: boolean;
}
export namespace KursanmeldungVO {
    export type ZertifizierungstypEnum = 'ZERTIFIZIERUNG' | 'REZERTIFIZIERUNG';
    export const ZertifizierungstypEnum = {
        ZERTIFIZIERUNG: 'ZERTIFIZIERUNG' as ZertifizierungstypEnum,
        REZERTIFIZIERUNG: 'REZERTIFIZIERUNG' as ZertifizierungstypEnum
    };
    export type WiderrufStatusEnum = 'NEU' | 'ABGELEHNT' | 'ANGENOMMEN';
    export const WiderrufStatusEnum = {
        NEU: 'NEU' as WiderrufStatusEnum,
        ABGELEHNT: 'ABGELEHNT' as WiderrufStatusEnum,
        ANGENOMMEN: 'ANGENOMMEN' as WiderrufStatusEnum
    };
}


